import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrLink from 'client/components/SrLink/SrLink';

const SrUtilityProfitActivationsTeam = ({ utilityPartner }) => {
  return (
    <SrBox
      bgColor="yellowLight"
      padding="20px 18px"
      borderRadius="14px"
      marginTop="11px"
      display="flex"
      justifyContent="space-between"
      boxShadow="0px 5px 21px 0px rgba(219, 176, 0, .12)"
      id="sr-utility-profit-activations-team"
    >
      <SrText font="greycliff" weight="800" fontSize="18px" color="green100">
        ✨ Invite Team Members (new feature!)
        <SrLink to={`/utility-profit/${utilityPartner?.slug}/settings/team`}>
          <SrText font="greycliff" weight="800" fontSize="18px" color="blue300" paddingLeft="10px">
            Invite your team here
          </SrText>
        </SrLink>
      </SrText>
    </SrBox>
  );
};

SrUtilityProfitActivationsTeam.propTypes = {
  utilityPartner: PropTypes.object.isRequired,
};

SrUtilityProfitActivationsTeam.displayName = 'SrUtilityProfitActivationsTeam';

export default SrUtilityProfitActivationsTeam;
